const config = {
        baseUrl: 'https://raw.githubusercontent.com/kompanycoder/user-manager-app/master/users.json' 
};

export default config;